import { Routes } from '@angular/router';
import { HomeComponent } from './home/home';
import { LoginComponent } from './login/login';
import { KycDashboardComponent } from './dashboard/kyc-dashboard';
import {
  businessManagementGuard,
  matrixAdminGuard,
  organizationAppGuard,
  questionnaireAdminGuard,
  userManagementGuard,
} from './core/auth.guards';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./forgot-password/forgot-password').then((m) => m.ForgotPasswordComponent),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./reset-password/reset-password').then((m) => m.ResetPasswordComponent),
  },
  {
    path: 'dashboard/kyc',
    component: KycDashboardComponent,
    canActivate: [organizationAppGuard],
  },
  {
    path: 'dashboard/kyc/completed',
    canActivate: [organizationAppGuard],
    loadComponent: () =>
      import('./kyc-completed/kyc-completed').then((m) => m.KycCompletedComponent),
  },
  {
    path: 'questionnaires',
    canActivate: [organizationAppGuard, questionnaireAdminGuard],
    loadComponent: () =>
      import('./questionnaires/questionnaires-list').then((m) => m.QuestionnairesListComponent),
  },
  {
    path: 'questionnaires/new',
    canActivate: [organizationAppGuard, questionnaireAdminGuard],
    loadComponent: () =>
      import('./questionnaires/questionnaires').then((m) => m.QuestionnairesComponent),
  },
  {
    path: 'questionnaires/:id',
    canActivate: [organizationAppGuard, questionnaireAdminGuard],
    loadComponent: () =>
      import('./questionnaires/questionnaires').then((m) => m.QuestionnairesComponent),
  },
  {
    path: 'users',
    canActivate: [organizationAppGuard, userManagementGuard],
    loadComponent: () => import('./users/users').then((m) => m.UsersComponent),
  },
  {
    path: 'matrices',
    canActivate: [organizationAppGuard, matrixAdminGuard],
    loadComponent: () => import('./matrices/matrices-list').then((m) => m.MatricesListComponent),
  },
  {
    path: 'matrices/new',
    canActivate: [organizationAppGuard, matrixAdminGuard],
    loadComponent: () => import('./matrices/matrices').then((m) => m.MatricesComponent),
  },
  {
    path: 'matrices/:id',
    canActivate: [organizationAppGuard, matrixAdminGuard],
    loadComponent: () => import('./matrices/matrices').then((m) => m.MatricesComponent),
  },
  {
    path: 'businesses',
    canActivate: [organizationAppGuard, businessManagementGuard],
    loadComponent: () => import('./businesses/businesses').then((m) => m.BusinessesComponent),
  },
  {
    path: 'invitations',
    canActivate: [organizationAppGuard, questionnaireAdminGuard],
    loadComponent: () => import('./invitations/invitations').then((m) => m.InvitationsComponent),
  },
  {
    path: 'dashboard/kyc/review',
    canActivate: [organizationAppGuard],
    loadComponent: () =>
      import('./kyc-review/kyc-review-list').then((m) => m.KycReviewListComponent),
  },
  {
    path: 'dashboard/kyc/review/:id',
    canActivate: [organizationAppGuard],
    loadComponent: () =>
      import('./kyc-review/kyc-review-detail').then((m) => m.KycReviewDetailComponent),
  },
  { path: '**', redirectTo: '' },
];
